// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-back-hover svg {
  /* text-primary-skyblue */
  --tw-text-opacity: 1 !important;
  color: rgb(39 170 225 / var(--tw-text-opacity)) !important;

  fill: currentColor;
}

.forgot-back-hover a {
  /* text-primary-skyblue */
  --tw-text-opacity: 1 !important;
  color: rgb(39 170 225 / var(--tw-text-opacity)) !important;
}

.link-text a {
  display: inline !important;
  font-size: 14px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/auth/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0DAA0D;;EAE1D,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B","sourcesContent":[".forgot-back-hover svg {\n  /* text-primary-skyblue */\n  --tw-text-opacity: 1 !important;\n  color: rgb(39 170 225 / var(--tw-text-opacity)) !important;\n\n  fill: currentColor;\n}\n\n.forgot-back-hover a {\n  /* text-primary-skyblue */\n  --tw-text-opacity: 1 !important;\n  color: rgb(39 170 225 / var(--tw-text-opacity)) !important;\n}\n\n.link-text a {\n  display: inline !important;\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
